import styled from 'styled-components';

export const CopyLink = styled.span`
  font-size: inherit;
  color: inherit;
  cursor: pointer;
  text-decoration: underline;
`;
